import * as React from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import { ActivityIndicator } from "../ActivityIndicator/ActivityIndicator";
import { Text } from "../Text/Text";

import { ButtonSize, buttonSizeToFontSize, FontWeight } from "./utils";
import Styles from "./Button.module.scss";
import { GCColor } from "../Icon/icon-prop-types";
import { FontSize } from "src/components/types";

type Type = "filled" | "stroke";

export interface ButtonProps {
  title?: string;
  disabled?: boolean;
  type?: Type;
  color?: GCColor;
  textColor?: GCColor;
  size?: ButtonSize;
  fontSize?: FontSize;
  fontWeight?: FontWeight;
  onClick?: () => void;
  link?: string;
  loading?: boolean;
  className?: string;
  width?: "fill" | "fixed";
  ["data-testid"]?: string;
  children?: React.ReactNode;
}

export const Button = (props: ButtonProps) => {
  if (props.link && !props.disabled) {
    const { link, className: linkStyles, ...otherProps } = props;
    return (
      <Link to={link} className={cn(Styles.buttonLink, linkStyles)}>
        <Button {...otherProps} />
      </Link>
    );
  }

  const {
    title = "",
    disabled = false,
    type = "filled",
    color = "gc-blue",
    textColor,
    size = "medium",
    fontSize,
    fontWeight = "bold",
    onClick,
    loading = false,
    className,
    width = "fixed",
    children,
  } = props;

  const defaultTextColor = type === "filled" ? "white" : color;
  const realTextColor = textColor || defaultTextColor;
  const realFontSize = fontSize === undefined ? buttonSizeToFontSize(size) : fontSize;
  const classes = cn(Styles[size], Styles[color], Styles[type], Styles[width], className);

  return (
    <button type="submit" onClick={onClick} className={classes} disabled={disabled || loading}>
      <ActivityIndicator.Spinner
        className={Styles.spinner}
        show={loading}
        size={size}
        color={type === "filled" ? "light" : "blue"}
      />
      <Text className={loading ? Styles["hide-text"] : ""} size={realFontSize} color={realTextColor} weight={fontWeight}>
        {title}
      </Text>
      {children}
    </button>
  );
};
